import {toast} from 'react-toastify';

let initialState = {
	infos: [],
	one: [],
	reponse: [],
	create: [],
	update: []
};

const getTicketsInfos = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_TICKETS_RETURN':
			return Object.assign({}, state, {infos: action.payload});

		case 'GET_TICKETREPONSE_RETURN':
			return Object.assign({}, state, {reponse: action.payload});

		case 'POST_REPONSE_RETURN':
			const arrayData = [action.payload.data];
			let newStateAdd;
			if (action.payload.status === 201) {
				newStateAdd = {...state.infos, data: state.infos.data.concat(arrayData)};
				const notifySuccess = () =>
					toast.success('Réponse envoyée !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				newStateAdd = state.infos;
				if (action.payload.status === 400) {
					const notifyError = () =>
						toast.error('ERREUR ! merci de le signaler...', {
							position: 'top-right',
							autoClose: 3000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
							progress: undefined
						});
					notifyError();
				}
			}
			return Object.assign({}, state, {
				create: action.payload,
				infos: newStateAdd
			});

		case 'DEL_TICKET_SAGAS':
			const ticket = state.infos.data;
			const indexTicket = ticket.findIndex((index) => index.uuid === action.payload);
			const newStateDelete = {...state.infos, data: ticket.filter((item, i) => i !== indexTicket)};

			return Object.assign({}, state, {infos: newStateDelete});

		case 'DEL_TICKET_RETURN':
			if (action.payload.status === 202) {
				const notifySuccess = () =>
					toast.success('Message supprimé !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				const notifyError = () =>
					toast.error('Erreur ! merci de le signaler...', {
						position: 'top-right',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifyError();
			}
			return Object.assign({}, state, {delete: action.payload});

		default:
			return state;
	}
};

export default getTicketsInfos;
